module.exports = __webpack_public_path__ + "img/IMG_1039_L_Foamcore_MockedUp.da6f0b50.jpg";